<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="800">
        <v-card class="full-card overflow-y-auto" elevation="3">
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h3>Add Assets</h3>

                <v-btn
                    density="compact"
                    icon="mdi-close"
                    variant="flat"
                    @click="$emit('update:modelValue', false)"
                />
            </v-card-title>


            <v-divider/>
            <v-card-text class="py-0 text-start">

                <v-text-field
                    v-model="search"
                    density="compact"
                    flat
                    hide-details
                    label="Search"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="solo-filled"
                ></v-text-field>
                <v-data-table
                    v-model="selectedAssets"
                    v-model:search="search"
                    :headers="headers"
                    :items="assets"
                    item-value="id"
                    show-select
                ></v-data-table>
            </v-card-text>
            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn size="small" type="button" @click="emits('update:modelValue', false)">
                    Close
                </v-btn>
                <v-btn :disabled="!selectedAssets.length" color="blue"
                       size="small"
                       @click="addAssets">Add Assets
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const props = defineProps({
    modelValue: Boolean,
    group: Object,
});

const {showSnackbar} = useSnackbarStore();
const emits = defineEmits(["update:modelValue", "addAsset"]);
const selectedAssets = ref([]);
const dialogSwitch = ref(props.modelValue);
const loading = ref(true);
const errors = ref([]);
const assets = ref([]);
const headers = ref([]);
const search = ref();
onMounted(() => {
    fetchAssets();
});

const fetchAssets = () => {
    loading.value = true;
    send("get", `groups/find-assets/${props.group.id}`)
        .then(({data}) => {
            assets.value = data.assets;
            headers.value = data.headers;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
            showSnackbar("Assets could not be loaded", "error");
        });
};

const addAssets = () => {
    errors.value = [];
    send("post", `groups/assign-assets/${props.group.id}`, {'assets': selectedAssets.value})
        .then(({data}) => {
            showSnackbar(data.message);
            if (data.success) {
                emits('addAsset', selectedAssets.value)
                emits('update:modelValue', false)
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })

}
</script>
